// src/hooks/useAuth.ts
import { useAuthContext } from "../context/AuthContext";
import {
    login as authLogin,
    logout as authLogout,
    refreshUser as authRefreshUser,
} from "../services/authService";

const useAuth = () => {
    const { authState } = useAuthContext();

    // login/logout/refresh all mutate pb.authStore, which the AuthProvider
    // subscribes to via authStore.onChange — so authState updates itself.
    const login = async (email: string, password: string) => {
        await authLogin(email, password);
    };

    const logout = () => {
        authLogout();
    };

    const refresh = async () => {
        await authRefreshUser();
    };

    return { authState, login, logout, refresh };
};

export default useAuth;
